import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Paper } from '@mui/material';

interface Props {
  isUnableToScan?: boolean;
  onUnableToScan: { (): void };
  otpSecretKey: string;
}

const ScanCode = (props: Props): React.JSX.Element => {
  const { isUnableToScan, onUnableToScan, otpSecretKey } = props;

  if (isUnableToScan) {
    return (
      <Paper>
        <Box p={2}>
          <Box mb={1}>
            <FormattedMessage defaultMessage="Enter the code below in your authenticator app instead:" />
          </Box>

          <Box fontWeight="bold">{otpSecretKey}</Box>
        </Box>
      </Paper>
    );
  }

  return (
    <Button variant="text" onClick={onUnableToScan}>
      <FormattedMessage defaultMessage="Unable to Scan This?" />
    </Button>
  );
};

export default memo(ScanCode);
